import React from 'react';
import { useSelector } from 'react-redux';

const DashboardOverview = () => {
  const { teamsuser } = useSelector(state => state.teamsAuth);
  
  
  // Safety check for user data
  const userInfo = teamsuser?.user || {};
  const isBillingActive = userInfo.isBillingActive === true;
  const workspaceName = userInfo.workspaceName;
  

  const games = [
    {
      title: "Trivia Contests",
      description: "Trivia Contests,Weekly trivia and custom quizzes",
      icon: "🧠",
      color: "#E04F60",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-trivia-contest"
    },
    {
      title: "Photo Quiz",
      description: "Play visual trivia contests with images",
      icon: "📸",
      color: "#3498DB",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-create-and-play-a-photo-quiz"
    },
    {
      title: "This or That",
      description: "Quick decision-making game for team preferences",
      icon: "🤔",
      color: "#27AE60",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-this-or-that"
    },
    {
      title: "Never Have I Ever",
      description: "Classic icebreaker game to learn about teammates",
      icon: "🙋",
      color: "#F39C12",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-never-have-i-ever"
    },
    {
      title: "Icebreakers",
      description: "Perfect conversation starters for team meetings",
      icon: "❄️",
      color: "#9B59B6",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-icebreakers"
    },
    {
      title: "Would You Rather",
      description: "Thought-provoking choices that spark discussions",
      icon: "🤷",
      color: "#E67E22",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-would-you-rather"
    },
    {
      title: "Most Likely To",
      description: "Fun predictions about team members",
      icon: "🏆",
      color: "#1ABC9C",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-most-likely-to"
    },
    {
      title: "Hot Takes",
      description: "Share and debate controversial opinions",
      icon: "🔥",
      color: "#E74C3C",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-hot-takes"
    },
    {
      title: "Fact or Fiction",
      description: "Test your team's ability to distinguish truth from lies",
      icon: "🕵️",
      color: "#34495E",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-fact-or-fiction"
    },
    {
      title: "Unpopular Opinions",
      description: "Debate controversial takes",
      icon: "💭",
      color: "#8E44AD",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-unpopular-opinions"
    },
    {
      title: "Coworkers",
      description: "Learn fun facts about your teammates",
      icon: "👥",
      color: "#16A085",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-coworkers"
    },
    {
      title: "Word of The Day",
      description: "Daily word guessing game similar to Wordle",
      icon: "📝",
      color: "#2980B9",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-word-of-the-day"
    },
    {
      title: "Tic-Tac-Toe",
      description: "Classic strategy game for quick competitions",
      icon: "⭕",
      color: "#27AE60",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-tic-tac-toe-and-rock-paper-scissors"
    },
    {
      title: "Rock Paper Scissors",
      description: "Quick hand game for instant fun",
      icon: "✂️",
      color: "#E67E22",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-tic-tac-toe-and-rock-paper-scissors"
    },
    {
      title: "Connect4",
      description: "Strategic four-in-a-row game",
      icon: "🔴",
      color: "#C0392B",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-connect4"
    },
    {
      title: "Snowman",
      description: "Word guessing game (like Hangman)",
      icon: "⛄",
      color: "#3498DB",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-snowman"
    },
    {
      title: "Odds and Evens",
      description: "Another quick hand game for instant fun",
      icon: "🎲",
      color: "#9B59B6",
      helpLink: "https://docs.ricotta.team/ricotta-games-and-trivia-on-microsoft-teams-1/how-to-play-odds-and-evens"
    }
  ];


  return (
    <div className="dashboard-overview" style={{ padding: '2rem' }}>
      <div className="container-fluid">
        {/* Welcome Section */}
        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ 
            color: '#E04F60', 
            marginBottom: '0.5rem',
            fontSize: '1.8rem',
            fontWeight: '600'
          }}>
            Welcome to Ricotta Games, Trivia & Icebreakers! 🎮
          </h2>
          <p style={{ color: '#6c757d', fontSize: '1.1rem' }}>
            Boost team engagement with fun games and activities for Microsoft Teams
          </p>
        </div>



        {/* Games Section */}


        <div className="row g-3" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {games.map((game, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12" style={{ 
              width: '25%', 
              minWidth: '250px',
              flex: '0 0 25%'
            }}>
              <div 
                className="card h-100 game-card"
                style={{
                  border: 'none',
                  borderRadius: '8px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  height: '180px'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.12)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.08)';
                }}
                onClick={() => {
                  window.open(game.helpLink, '_blank', 'noopener,noreferrer');
                }}
              >
                <div className="card-body d-flex flex-column justify-content-center" style={{ 
                  padding: '1rem 0.75rem',
                  textAlign: 'center'
                }}>
                  <div style={{
                    fontSize: '2rem',
                    marginBottom: '0.5rem'
                  }}>
                    {game.icon}
                  </div>
                  
                  <h6 className="card-title" style={{
                    color: game.color,
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    marginBottom: '0.5rem',
                    lineHeight: '1.2'
                  }}>
                    {game.title}
                  </h6>
                  
                  <p className="card-text" style={{
                    color: '#6c757d',
                    fontSize: '0.75rem',
                    lineHeight: '1.3',
                    marginBottom: '0.5rem',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                  }}>
                    {game.description}
                  </p>

                  <div>
                    <small style={{ 
                      color: game.color, 
                      fontWeight: '600',
                      fontSize: '0.7rem'
                    }}>
                      📖 Help Guide →
                    </small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-5">
          <div style={{
            backgroundColor: 'rgba(224, 79, 96, 0.1)',
            borderRadius: '12px',
            padding: '2rem',
            border: '2px solid rgba(224, 79, 96, 0.2)'
          }}>
            <h4 style={{ color: '#E04F60', marginBottom: '1rem' }}>
              Ready to get started?
            </h4>
            <p style={{ color: '#6c757d', marginBottom: '1.5rem' }}>
              {isBillingActive
                ? "You're all set! Start playing games with your team."
                : "Subscribe to a plan to unlock all games and features."
              }
            </p>
            {!isBillingActive && (
              <button
                style={{
                  backgroundColor: '#E04F60',
                  color: 'white',
                  border: 'none',
                  padding: '1rem 2rem',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#c94456';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#E04F60';
                  e.target.style.transform = 'translateY(0)';
                }}
                onClick={() => {
                  // This will be handled by parent component
                  window.dispatchEvent(new CustomEvent('navigate-to-billing'));
                }}
              >
                View Pricing Plans →
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview;
